import { environmentName } from '../config';

export function generateProposalPageURL(proposalId: string, vendorGUID: string): string {
  return `https://app${
    environmentName === 'dev' ? '.dev' : ''
  }.trnsact.com/ps/?vendorGUID=${vendorGUID}&proposalId=${proposalId}&viewOnly=true`;
}
